export default __webpack_public_path__ + "fonts/montserrat-light-webfont.woff";